import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';

import { graphql, compose } from 'react-apollo';

// Redux
import { connect } from 'react-redux';

import {
	Button,
	Label
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../Inbox.css';
import bt from "../../../components/commonStyle.css";

// Component
import Avatar from '../../Avatar';
import Link from '../../Link';

// Redux Action
import { readMessage } from '../../../actions/message/readMessage';

// Locale
import messages from '../../../locale/messages';

import { archiveThread } from '../../../actions/archiveThread';

// Graphql 
import GetAllThreadQuery from '../AllThreadsQuery.graphql';
import { DATE_FORMAT_DISPLAY } from '../../../constants';
class InboxItem extends Component {
	static propTypes = {
		formatMessage: PropTypes.any,
		type: PropTypes.string.isRequired,
		status: PropTypes.string.isRequired,
		threadId: PropTypes.number.isRequired,
		profileId: PropTypes.number.isRequired,
		picture: PropTypes.string,
		displayName: PropTypes.string.isRequired,
		content: PropTypes.string,
		createdAt: PropTypes.string.isRequired,
		startDate: PropTypes.string,
		endDate: PropTypes.string,
		sentBy: PropTypes.string.isRequired,
		city: PropTypes.string.isRequired,
		state: PropTypes.string.isRequired,
		country: PropTypes.string.isRequired,
		read: PropTypes.bool.isRequired,
		account: PropTypes.shape({
			userId: PropTypes.string.isRequired
		}),
		readMessage: PropTypes.any.isRequired,
		archiveThread: PropTypes.func.isRequired,
	};

	static defaultProps = {
		createdAt: null,
		startDate: null,
		endDate: null,
		picture: null,
		status: null,
		sentBy: null,
		read: false
	}

	state = {
		loading: false, // Initialize loading state
	};

	moveTo = async (id, isArchive) => {
		this.setState({ loading: true }); // Disable button
		try {
			await this.props.archiveThread(id, isArchive); // Dispatch async action
		} catch (error) {
			console.error('Archive thread failed:', error);
		} finally {
			this.setState({ loading: false });
		}
	};

	label(status, noStyle) {
		let style, label;
		switch (status) {
			case 'inquiry':
				label = <FormattedMessage {...messages.messageStatus1} />
				style = 'info';
				break;
			case 'preApproved':
				label = <FormattedMessage {...messages.messageStatus2} />
				style = 'primary';
				break;
			case 'declined':
				label = <FormattedMessage {...messages.messageStatus3} />
				style = 'danger';
				break;
			case 'approved':
				label = <FormattedMessage {...messages.messageStatus4} />
				style = 'success';
				break;
			case 'pending':
				label = <FormattedMessage {...messages.messageStatus5} />
				style = 'warning';
				break;
			case 'cancelledByHost':
				label = <FormattedMessage {...messages.messageStatus6} />
				style = 'danger';
				break;
			case 'cancelledByGuest':
				label = <FormattedMessage {...messages.messageStatus7} />
				style = 'danger';
				break;
			case 'intantBooking':
				label = <FormattedMessage {...messages.messageStatus8} />
				style = 'success';
				break;
			case 'instantBooking':
				label = <FormattedMessage {...messages.messageStatus8} />
				style = 'success';
				break;
			case 'confirmed':
				label = <FormattedMessage {...messages.messageStatus8} />
				style = 'success';
				break;
			case 'expired':
				label = <FormattedMessage {...messages.messageStatus9} />
				style = 'danger';
				break;
			case 'requestToBook':
				label = <FormattedMessage {...messages.messageStatus10} />
				style = 'primary';
				break;
			case 'completed':
				label = <FormattedMessage {...messages.inboxCompleted} />
				style = 'success';
				break;
		}
		if (noStyle) {
			return label;
		}
		return <Label bsStyle={style}>{label}</Label>
	}

	render() {
		const { type, threadId, profileId, picture, displayName, content, createdAt, startDate, endDate, isArchive } = this.props;
		
		const { city, state, country, status, sentBy, read } = this.props;
		const { formatMessage } = this.props.intl;
		const { account: { userId } } = this.props;
		const { readMessage } = this.props;
		let loading = false;
		let createdDate = createdAt != null ? moment(Number(createdAt)).format(DATE_FORMAT_DISPLAY) : '';
		let start = startDate != null ? '(' + moment(startDate).format(DATE_FORMAT_DISPLAY) : '';
		let end = endDate != null ? ' - ' + moment(endDate).format(DATE_FORMAT_DISPLAY) + ')' : '';
		let isRead;
		if (userId !== sentBy && read === false) {
			isRead = s.threadSubjectUnread;
		}

		return (
			<div className={s.listAvatarFlex}>
				<div className={cx(s.threadAvatar, 'inboxAvatar')}>
					<Avatar
						source={picture}
						height={75}
						width={75}
						title={displayName}
						className={s.profileAvatar}
						withLink
						linkClassName={s.profileAvatarLink}
						profileId={profileId}
					/>
				</div>
				<div className={cx(s.listDeatilsGrid, bt.unarchiveGrey, 'listingTagCurve grayBgCurve')}>
					<div className={cx(s.width30)}>
						<Link to={"/users/show/" + profileId} className={cx(s.listTitle, 'textWhite')}>
							{displayName}
						</Link>
						<p className={cx(s.cityText, s.noMargin, 'textWhite')}>{createdDate}</p>
					</div>
					<div className={cx(s.titleWidth,s.width42)}>
						<Link
							to={"/message/" + threadId + "/" + (type == "guest" ? type : "host")}
							className={cx(s.listTitle, s.greenColor)}
							onClick={() => readMessage(threadId, type)}
						>
							<div>
								<span className={cx({ [s.threadSubjectUnread]: userId !== sentBy && read === false, 'threadSubjectUnreadRTL': userId !== sentBy && read === false }, 'textWhite', s.statusText)}>{content != null ? content : this.label(status, true)}</span>
								<p className={cx(s.cityText, s.linkDecoration, s.spaceTop10, 'textWhite')}>{city}, {state}, {country}</p>
								<p className={cx(s.cityText, s.noMargin, s.linkDecoration, 'textWhite')}>{start} {end}</p>
							</div>
						</Link>

					</div>
					<div className={cx('messageStatus',s.width28)}>
						{ (type =='host' || type == 'archive' ) && ['declined', 'cancelledByHost', 'cancelledByGuest', 'expired', 'completed', 'message'  ].includes(status) && <Button
							className={cx(bt.btnPrimary, isArchive ? bt.unArchiveButton : bt.archiveButton )}
							disabled={loading}
							onClick={() => this.moveTo(threadId, isArchive ? 0 : 1)}
							> 
							<FormattedMessage {...(isArchive ? messages.unArchiveLabel : messages.archiveLabel)} />
							</Button>
						}
						{this.label(status)}
						
					</div>
					<div className={s.contentSectionBtn}>			
					</div>
				</div>
			</div>
		);
	}
}

const mapState = (state) => ({
	account: state.account.data,
	loading: state.loading
});

const mapDispatch = {
	readMessage,
	archiveThread
};


export default compose(
	injectIntl,
	withStyles(s),
	connect(mapState, mapDispatch),
	graphql(GetAllThreadQuery, {
		name: 'GetAllThreads',
		options: {
			ssr: false,
			pollInterval: 5000,
			fetchPolicy: 'network-only',
		}
	})
)(InboxItem);